<div class="checkout-item-list">
  <div class="checkout-product-order">
    {{ "checkoutorderlist.description" | cxTranslate }}
  </div>
  
  <div class="row headers">
    <div class="col-6">
      
    </div>
    <div class="col-1">{{ "checkoutorderlist.quantity" | cxTranslate }}</div>
    <div class="col-1">{{ "checkoutorderlist.itemPrice" | cxTranslate }}</div>
    <div class="col-2">{{ "checkoutorderlist.discount" | cxTranslate }}</div>
    <div class="col-2">{{ "checkoutorderlist.total" | cxTranslate }}</div>
  </div>
  <div class="row mt-4" *ngFor="let item of entries; let i = index">
    <div class="col-6 ">
      <div class="float-left">
        <img class="imageAvailable" *ngIf="item.product && item.product.images && item.product.images.length" src="{{item.product.images[2].url}}" alt="image"/>
        <img class="imageNotAvailable" *ngIf="item.product && !item.product.images" src="{{ '../../../../../../../assets/images/tea-hot-icon.svg'}}" alt="image"/>
      </div>
      <div class="float-left ml-3 mt-4 vstack gap-0 align-middle text-truncate">
        <div class="text-wrap">
        {{item?.product?.name}}
        </div>
        <div class="text-wrap">
          {{ "checkoutorderlist.sku" | cxTranslate }} {{item?.product?.code}}
          </div>
          <div class="clearfix"></div>
      </div>
      
    </div>
    <div class="col-1 values align-middle">{{item?.quantity}}</div>
    <div class="col-1 values align-middle">{{item?.basePrice?.formattedValue}}</div>
    <div class="col-2 values align-middle">{{item?.orderEntryDiscountAmount?.formattedValue}}</div>
    <div class="col-2 subtotal align-middle">{{item?.totalPrice?.formattedValue}}</div>
  </div>
</div>